import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Textarea from 'components/Common/Forms/Textarea';
import { NegativeNotice } from 'next/components/ui';

const Wrapper = styled.div`
  ${NegativeNotice} {
    margin-bottom: 10px;
  }
`;

const PropertyTextArea = ({
  isErrored,
  propertyLength,
  value,
  onChange,
  onDismissError,
  onBlur,
}) => {
  return (
    <Wrapper>
      {isErrored && (
        <NegativeNotice onDismiss={onDismissError}>
          Only the maximum 1,000 values will be saved.
        </NegativeNotice>
      )}
      <Textarea
        className="property-clause_text-area"
        resize
        isError={isErrored}
        value={(`${value}` || '').replace(/&#44;/g, '\\,')}
        placeholder="Enter values separated by commas or line breaks"
        onChange={onChange}
        onBlur={onBlur}
      />
      <p>{`${propertyLength}/1000`}</p>
    </Wrapper>
  );
};

PropertyTextArea.propTypes = {
  isErrored: PropTypes.bool,
  propertyLength: PropTypes.number.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onDismissError: PropTypes.func,
  onBlur: PropTypes.func.isRequired,
};

export default PropertyTextArea;
